import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect
} from '@angular/core';
import { AuthService, Permission } from '@umss/shared/data-access';

@Directive({
  selector: '[umssHasPermission]',
  standalone: true
})
export class UmssHasPermissionDirective {
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private authService = inject(AuthService);

  private requiredPermissions: Permission[] = [];
  private logicalOp: 'AND' | 'OR' = 'OR';
  private hasView = false;

  @Input('umssHasPermission') set permissions(
    value: Permission | Permission[]
  ) {
    this.requiredPermissions = Array.isArray(value) ? value : [value];
    this.updateView();
  }

  @Input('umssHasPermissionOp') set op(val: 'AND' | 'OR') {
    this.logicalOp = val;
    this.updateView();
  }

  constructor() {
    effect(() => {
      // Create a dependency on auth state
      this.authService.authState();
      this.updateView();
    });
  }

  private updateView() {
    const userPermissions = this.authService.authState().permissions || [];

    let hasPermission = true;

    if (
      this.requiredPermissions.length > 0 &&
      (!this.authService.authState().corporateId ||
        this.authService.authState().corporateId?.trim() === '')
    ) {
      if (this.logicalOp === 'OR') {
        hasPermission = this.requiredPermissions.some((p) =>
          userPermissions.includes(p)
        );
      } else {
        hasPermission = this.requiredPermissions.every((p) =>
          userPermissions.includes(p)
        );
      }
    } else {
      // If users pass empty array, they probably want to show it (no restriction).
      hasPermission = true;
    }

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
